import { UOMS, UomTypes } from '@amzn/awscat-portfolio-assessment-types';

export const HOURS_PER_DAY = 24;
export const WEEKS_PER_YEAR = 52;
export const DAYS_PER_YEAR = 365;
export const MONTHS_PER_YEAR = 12;
export const DAYS_PER_WEEK = 7;
export const QUARTERS_PER_YEAR = 4;
export const WEEKS_TO_MONTH = DAYS_PER_YEAR / MONTHS_PER_YEAR / DAYS_PER_WEEK;
export const ONE_HUNDRED = 100;
export const ONE_THOUSAND = 1000;

type UnitPower =  {
    [unit in UOMS]: number;
};
const UNIT_POWER: UnitPower = {
    Byte: 0,
    KB: 1,
    MB: 2,
    GB: 3,
    TB: 4,
    Hz: 10,
    KHz: 11,
    MHz: 12,
    GHz: 13,
    Percentage: 20,
    Decimal: 21,
};

const STORAGE_BASE = 1024;
const FREQUENCY_BASE = 1000;
const PERCENTAGE_BASE = 100;
export function uomConversion(value: number | string, fromUnit: UOMS, targetUnit: UOMS): number {
    const originalNumber = Number(value);
    const fromUnitPower = UNIT_POWER[fromUnit];
    const targetUnitPower = UNIT_POWER[targetUnit];
    const powerDiff = fromUnitPower - targetUnitPower;

    // Corner case: fromUnit and targetUnit not convertible
    if (Math.abs(powerDiff) > 5) {
        return originalNumber;
    }
    
    switch(Math.floor(fromUnitPower / 10)) {
        case 0: {
            // Storage conversion
            return originalNumber * Math.pow(STORAGE_BASE, powerDiff);
        }
        case 1: {
            // Frequency conversion
            return originalNumber * Math.pow(FREQUENCY_BASE, powerDiff);
        }
        case 2: {
            // Percentage conversion
            return originalNumber * Math.pow(PERCENTAGE_BASE, powerDiff);
        }
        default: {
            return originalNumber;
        }
    }
}

type DefaultDatabaseUOM = {
    [uomType in UomTypes]: UOMS;
}
// Indicate the UOM that used in Database
export const DEFAULT_DATABASE_UOM: DefaultDatabaseUOM = {
    'Percentage': UOMS.DECIMAL,
    'Frequency': UOMS.GHz,
    'Memory-Storage': UOMS.KB,
};
